"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Focus_1 = __importDefault(require("./Focus/Focus"));
var IntegrationFocusCreator = (function () {
    function IntegrationFocusCreator(make, account, noop) {
        this.make = make;
        this.account = account;
        this.noop = noop;
    }
    IntegrationFocusCreator.prototype.create = function (item, onClose) {
        if (item == null) {
            throw new Error("Trying to show settings without passing in an integration item");
        }
        if (onClose == null) {
            onClose = this.noop;
        }
        var name = item.internalName;
        var account = this.account;
        return this.make(Focus_1.default, {
            integration: item,
            isEnabled: function () {
                return account.integrations[name] != null && account.integrations[name].enabled;
            },
            onClose: onClose,
        });
    };
    return IntegrationFocusCreator;
}());
exports.default = IntegrationFocusCreator;
